import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { Skeleton } from 'antd'
import { Bar } from '@ant-design/charts'
import { map, size } from 'lodash-es'
import { Panel } from '../../../core/components/styled'
import { getQueryParams } from '../../../core/utils/services/queryParams'
import { SCRAPING_TAG_TYPES } from '../../constants'
import { SCRAPING_TEST_CASE_COUNTS_BY_TAG_TYPES } from '../../graphql/queries'
import { ScrapingTagsFilter } from './sections'

const ScrapingTestCaseDistributionPage = () => {
  const { search } = useLocation()
  const { tagIds } = getQueryParams(search)

  const {
    data: { scrapingTestCaseCountsByTagTypes = {} } = {},
    loading: isLoading,
  } = useQuery(SCRAPING_TEST_CASE_COUNTS_BY_TAG_TYPES, {
    variables: {
      tagIds,
    },
    fetchPolicy: 'no-cache',
  })

  const data = useMemo(
    () =>
      map(scrapingTestCaseCountsByTagTypes, ({ type, name, count }) => ({
        label: `${SCRAPING_TAG_TYPES[type].name}: ${name}`,
        count,
      })),
    [scrapingTestCaseCountsByTagTypes],
  )

  const barChartConfig = useMemo(
    () => ({
      data,
      height: size(data) > 10 ? size(data) * 25 : 400,
      xField: 'count',
      yField: 'label',
      seriesField: 'label',
      legend: { position: 'top-left' },
    }),
    [data],
  )

  return isLoading ? (
    <Skeleton active />
  ) : (
    <>
      <Panel>
        <ScrapingTagsFilter />
      </Panel>
      <Bar {...barChartConfig} />
    </>
  )
}

export default ScrapingTestCaseDistributionPage
